import { render, staticRenderFns } from "./menucategory.vue?vue&type=template&id=4ac74242&scoped=true&"
import script from "./menucategory.vue?vue&type=script&lang=js&"
export * from "./menucategory.vue?vue&type=script&lang=js&"
import style0 from "./menucategory.vue?vue&type=style&index=0&id=4ac74242&prod&lang=scss&"
import style1 from "./menucategory.vue?vue&type=style&index=1&id=4ac74242&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac74242",
  null
  
)

export default component.exports